import { DialogActions, DialogContent } from "@mui/material";
import {
  Autocomplete,
  Button,
  Checkbox,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
} from "common";
import { ParamsContext } from "common/components/Form/ParamsContext";
import I18n from "i18n";
import useNotificationAddressForm, {
  UseNotificationAddressFormProps,
} from "./useNotificationAddressForm";

export interface NotificationAddressFormProps
  extends UseNotificationAddressFormProps {}

export default function NotificationAddressForm({
  id,
  afterSave,
  onClose,
  defaultValues,
}: NotificationAddressFormProps) {
  const form = useNotificationAddressForm({ id, afterSave, defaultValues });
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = form;
  const title = isCreate
    ? I18n.t("NotificationAddress.addTitle")
    : I18n.t(`NotificationAddress.options.key.${item.key}`);

  return (
    <ParamsContext.Provider value={{ notificationAddress_id: id }}>
      <PageHeader title={title} onClose={onClose} loading={loading} />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="NotificationAddress.attributes"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
          disabledFields={["send_push", "send_email"]}
        >
          <FieldsContainer>
            <Field fullWidth>
              <Autocomplete id="key" />
            </Field>
            <Field fullWidth>
              <Autocomplete multiple id="user_ids" />
            </Field>
            <Field fullWidth>
              <Autocomplete
                value={item?.external_emails || []}
                multiple
                freeSolo
                id="external_emails"
              />
            </Field>
            <Field fullWidth>
              <Checkbox id="send_email" />
              <Checkbox id="send_push" />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </ParamsContext.Provider>
  );
}
